/* Metricool website analytics: respect Shopify's existing analytics permission. */
(() => {
  if (window.bojunaMetricoolInstalled || window.Shopify?.designMode) return;
  window.bojunaMetricoolInstalled = true;
  let loading = false;
  let recorded = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  const record = () => {
    if (recorded || !allowed() || typeof window.beTracker?.t !== 'function') return;
    recorded = true;
    window.beTracker.t({ hash: '3cf75228306189eaf32a99414ec0d209' });
  };
  const connect = () => {
    if (recorded || !allowed()) return;
    if (typeof window.beTracker?.t === 'function') { record(); return; }
    if (loading) return;
    loading = true;
    const existing = document.querySelector('script[src="https://tracker.metricool.com/resources/be.js"]');
    const script = existing || document.createElement('script');
    script.addEventListener('load', record, { once: true });
    if (!existing) {
      script.src = 'https://tracker.metricool.com/resources/be.js';
      script.async = true;
      document.head.appendChild(script);
    }
  };
  document.addEventListener('visitorConsentCollected', connect);
  if (window.Shopify?.customerPrivacy) connect();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) connect();
    });
  }
})();
